import { render, staticRenderFns } from "./ResultStatistics.vue?vue&type=template&id=67d051a9&scoped=true&"
import script from "./ResultStatistics.vue?vue&type=script&lang=js&"
export * from "./ResultStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ResultStatistics.vue?vue&type=style&index=0&id=67d051a9&lang=less&scoped=true&"
import style1 from "./ResultStatistics.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d051a9",
  null
  
)

export default component.exports